(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portal-login"] && !Shopify.designMode) return;
  try {
    
(function () {
  function readConfig() {
    var node = document.querySelector('[data-portal-login-config]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf(prefix) === 0) {
        return cookies[i].slice(prefix.length);
      }
    }

    return '';
  }

  function setCookie(name, days) {
    var expires = new Date();
    expires.setMonth(expires.getMonth() + 1);

    document.cookie =
      name +
      '=1; expires=' +
      expires.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function openPopup(popup) {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('portal-login-locked');
  }

  function closePopup(popup) {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('portal-login-locked');
  }

  var config = readConfig();
  if (!config) return;

  var popup = document.getElementById('PortalLogin-' + config.sectionId);
  if (!popup) return;

  if (getCookie(config.cookieName) === '1') {
    closePopup(popup);
    return;
  }

  openPopup(popup);

  var form = popup.querySelector('[data-portal-login-form]');
  var input = popup.querySelector('#PortalLoginPw-' + config.sectionId);
  var error = popup.querySelector('[data-portal-login-error]');

  if (!form || !input) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var value = input.value.trim();
    var isValid = value === (config.password || '');

    if (isValid) {
      setCookie(config.cookieName, config.cookieDays);
      input.classList.remove('lk-input-err');
      if (error) error.hidden = true;
      closePopup(popup);
      return;
    }

    input.classList.add('lk-input-err');
    if (error) error.hidden = false;
    input.focus();
  });

  input.addEventListener('input', function () {
    input.classList.remove('lk-input-err');
    if (error) error.hidden = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["season-toolbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.season-toolbar').forEach(function (toolbar) {
    var tabs = toolbar.querySelectorAll('[data-season-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) {
          item.classList.remove('docs-tab-on');
          item.removeAttribute('aria-current');
        });

        tab.classList.add('docs-tab-on');
        tab.setAttribute('aria-current', 'true');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
